module.exports = __webpack_public_path__ + "media/images/lb/103-5b22b1f7165adf52b7e39753c32b2141.svg";